import axios from 'axios';
import Qs from 'qs';
import { Toast } from 'vant';


const isProduction = process.env.NODE_ENV === 'production'
if (isProduction) {
  console.log('%c 如果你看到这条 log , 说明当前是生产环境 ', 'font-size:14px;color:#f00;background:#000')
} else {
  console.log('%c 如果你看到这条 log , 说明当前是开发环境 ', 'font-size:14px;color:#f00;background:#000')
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,  // api的base_url
  timeout: 30000                  // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {

  if(config.url.indexOf("fileUpload")>0){
    config.headers['Content-Type'] ='multipart/form-data';
  }

  if (config.headers['Content-Type'] != 'application/json') {
    config.transformRequest = [function (data) {
      data = Qs.stringify(data, { indices: false });
      return data;
    }];
  }

  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.success !== true) {
      Toast.fail({
        message: res.msg,
        duration: 3000
      });
    } else {
      return response.data;
    }
  },
  error => {
    console.log('err' + error);// for debug
    Toast({
      message: error.message,
      duration: 3000
    });
    return Promise.reject(error);
  }
)


export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js